import { useEffect, useRef } from "react";
import { CommandMenu } from "./CommandMenu";
import { CopilotPanel } from "./copilot-panel/CopilotPanel";

import { ScratchPad } from "@/features/reader/notes/ScratchPad";
import { useAppState } from "@/store/useApp";
import OnboardingBlockHintFlow from "./ onboarding/flows/OnboardingBlockHintFlow";
import OnboardingReaderCardFlow from "./ onboarding/flows/OnboardingReaderAnnouncementFlow";
import OnboardingGuide from "./ onboarding/OnboardingGuide";
import { DiscrepanciesPanel } from "./DiscrepanciesPanel";
import { Document as DocumentComponent } from "./document/Document";
import { KeyboardShortcutsDialog } from "./KeyboardShortcutsDialog";
import { ReaderPanel } from "./side-panel/ReaderPanel";

interface ReaderProps {
  toggleKeyboardShortcuts: () => void;
  toggleCommandMenu: () => void;
  toggleCopilot: () => void;
  toggleDiscrepanciesPanel: () => void;
}

export const Reader = ({
  toggleCopilot,
}: ReaderProps) => {
  
  const selectedBlockRef = useRef<HTMLDivElement>(null!);
  const copilotVisible = useAppState((state) => state.copilotVisible);  
  const isNoteEditorOpen = useAppState((state) => state.isNoteEditorOpen);
  const selectedBlockIndex = useAppState((state) => state.selectedBlockIndex);

  useEffect(() => {
    if (selectedBlockRef.current) {
      requestAnimationFrame(() => {
        selectedBlockRef.current?.scrollIntoView({
          behavior: "smooth",
          block: isNoteEditorOpen ? "start" : "center",
        });
      });
    }
  }, [selectedBlockIndex, isNoteEditorOpen]);

  return (
    <div className="flex w-full h-full bg-white relative">
      <CommandMenu />
      <KeyboardShortcutsDialog />

      <OnboardingBlockHintFlow />
      <OnboardingGuide />
      <OnboardingReaderCardFlow />

      {!copilotVisible && (
        <div
          onClick={toggleCopilot}
          className="fixed -left-8 top-1/2 -translate-y-1/2 -rotate-90 origin-center cursor-pointer "
        >
          <div className="bg-purple-50 text-purple-600 hover:bg-purple-100 hover:text-purple-700 border border-purple-300 rounded-b-md">
            <div className="text-xs mx-4 my-[6px]">Ask Claire</div>
          </div>
        </div>
      )}

      <CopilotPanel />

      <div className="flex-1">
        <DocumentComponent
          selectedBlockRef={selectedBlockRef}
        />
      </div>
      
      <ReaderPanel />
      <DiscrepanciesPanel />
      <ScratchPad />
    </div>
  );
};
